import React from 'react';

import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';

import { FormInput, Button } from 'modules/common/input';

import { forgotPasswordSchema } from '../validation';
import { usePostForgotPassword } from '../hooks';

const INIT_FORM = {
  email: '',
};

function ForgotPasswordForm() {
  const history = useHistory();
  const [isApiLoading, post] = usePostForgotPassword();

  const { values, errors, setFieldValue, handleSubmit } = useFormik({
    initialValues: INIT_FORM,
    validationSchema: forgotPasswordSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (payload) => {
      post(payload, () => {
        history.push('/merchant-login');
      });
    },
  });

  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="space-y-5">
        <FormInput
          name="email"
          label="Email Address"
          icon={false}
          value={values?.email || ''}
          error={errors?.email}
          onSetFieldValue={setFieldValue}
          type="email"
          required
        />

        <div className="space-y-3 text-center">
          <Button
            isLoading={isApiLoading}
            type="submit"
            className="btn primary md w-full mb-3"
            label="Submit"
          />

          <Button
            to="/merchant-login"
            className="w-full text-center text-sm font-medium text-black my-3 hover:underline"
            label="Go back to merchant login"
          />
        </div>
      </div>
    </form>
  );
}

ForgotPasswordForm.propTypes = {};

export default ForgotPasswordForm;
